<div>
  <span class="kendoDropList">
    <span class="kendoDrop">
      <select class="state-select styled-dropdown form-control mb15"
              [required]="required"
              [(ngModel)]="state"
              [disabled]="disabled || states?.length === 0"
              name="state"
              id="state"
              [style.min-width.px]="popupWidth(states, 'abbreviation')"
              aria-label="State">
        @for(s of states; track s.abbreviation)
        {
        <option [value]="s.abbreviation"
                [innerHTML]="s.abbreviation" class="input-dropdown-screenvalue">
        </option>
        }
      </select>
    </span>
  </span>
</div>
